import { Col, Row } from 'antd'
import React, { useEffect, useRef } from 'react';

function ActionsLogItem(prop) {
    const containerRef = useRef(null);

    const timeStamp = prop.data.timeStamp
    const heading = prop.data.head
    const subHeading = prop.data.subHead
    const body = prop.data.body

    const handleHeight = (e) =>{
        prop.getHeight(e)
    }

    useEffect(() => {
        handleHeight(containerRef.current.clientHeight)
    }, []);

    return (
        <div ref={containerRef} style={{paddingTop:8}}>
            <Row >
                <Col span={1} />
                <Col span={4} style={{ display: "flex", alignItems: "center" }}> <p>{timeStamp}</p></Col>
                <Col>
                    <p style={{ fontSize: "14px" }}><b>{heading}</b> <i>{subHeading}</i></p>
                    <p style={{ fontSize: "12px" }}>
                       {body}
                    </p>
                </Col>
                <Col span={1} />
            </Row>

            <Row style={{padding:"6px 24px"}}>
                <Col span={24} style={{ borderBottom: '1px solid var(--hr-color)' }} />
            </Row>
        </div>
    )
}

export default ActionsLogItem